/**
 * @generated SignedSource<<53bd5c336d20b42849c66107261a534f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ShareModalPublicLinkMutation$variables = {
  enabled: boolean;
  id: string;
};
export type ShareModalPublicLinkMutation$data = {
  readonly noteStreamTogglePublicLink: {
    readonly noteStream: {
      readonly id: string;
      readonly index: number | null;
      readonly publicLink: {
        readonly enabled: boolean;
        readonly url: string;
      } | null;
    };
  } | null;
};
export type ShareModalPublicLinkMutation = {
  response: ShareModalPublicLinkMutation$data;
  variables: ShareModalPublicLinkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "enabled"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "enabled",
    "variableName": "enabled"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "index",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabled",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ShareModalPublicLinkMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "NoteStreamTogglePublicLink",
        "kind": "LinkedField",
        "name": "noteStreamTogglePublicLink",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "noteStream",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteStreamPublicLink",
                "kind": "LinkedField",
                "name": "publicLink",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ShareModalPublicLinkMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "NoteStreamTogglePublicLink",
        "kind": "LinkedField",
        "name": "noteStreamTogglePublicLink",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "noteStream",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteStreamPublicLink",
                "kind": "LinkedField",
                "name": "publicLink",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8292c00b0bebb8da9bfde9dea1bcd565",
    "id": null,
    "metadata": {},
    "name": "ShareModalPublicLinkMutation",
    "operationKind": "mutation",
    "text": "mutation ShareModalPublicLinkMutation(\n  $id: ID!\n  $enabled: Boolean!\n) {\n  noteStreamTogglePublicLink(id: $id, enabled: $enabled) {\n    noteStream {\n      id\n      index\n      publicLink {\n        url\n        enabled\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6a31be53b62c324bc59e49b32646b0c3";

export default node;
